import { render, staticRenderFns } from "./VireedChatProject.vue?vue&type=template&id=f5500c2c&"
import script from "./VireedChatProject.vue?vue&type=script&lang=js&"
export * from "./VireedChatProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports